import { render, staticRenderFns } from "./Bet.vue?vue&type=template&id=14494851&scoped=true&"
import script from "./Bet.vue?vue&type=script&lang=js&"
export * from "./Bet.vue?vue&type=script&lang=js&"
import style0 from "./Bet.vue?vue&type=style&index=0&id=14494851&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14494851",
  null
  
)

export default component.exports